import { render, staticRenderFns } from "./treeManagementList.vue?vue&type=template&id=6132a695&scoped=true"
import script from "./treeManagementList.vue?vue&type=script&lang=js"
export * from "./treeManagementList.vue?vue&type=script&lang=js"
import style0 from "./treeManagementList.vue?vue&type=style&index=0&id=6132a695&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132a695",
  null
  
)

export default component.exports